module.exports = __webpack_public_path__ + "static/media/facebook-store.a776227c.png";